import { render, staticRenderFns } from "./Nominas.vue?vue&type=template&id=d5f49f60&"
import script from "./Nominas.vue?vue&type=script&lang=js&"
export * from "./Nominas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports